import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from "@angular/common/http";

import { AppCommonModule } from "@common/app-common.module";
import { NavigationModule } from "@modules/navigation/navigation.module";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { NgxGoogleAnalyticsModule } from "ngx-google-analytics";
import { GoogleTagManagerModule } from "angular-google-tag-manager";
import { FormioModule } from "@formio/angular";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { CookieService } from "ngx-cookie-service";

import { InactivityAlertComponent } from "./components/inactivity-alert/inactivity-alert.component";
import { LogoutAlertComponent } from "./components/logout-alert/logout-alert.component";
import { ExitImpersonationModalComponent } from "./components/exit-impersonation-modal/exit-impersonation-modal.component";
import { ExitImpersonationConfirmModalComponent } from "./components/exit-impersonation-confirm-modal/exit-impersonation-confirm-modal.component";
import { ImpersonationConfirmModalComponent } from "./components/impersonation-confirm-modal/impersonation-confirm-modal.component";
import { TestComponent } from "./components/test/test.component";
import { MeteringSectionFormBuilderComponent } from "./components/metering-section-form-builder/metering-section-form-builder.component";

import { SecurityHeadersInterceptor } from "./interceptors/security-headers.service";
import { GlobalErrorInterceptor } from "./interceptors/global-error.interceptor";
import { PrismService } from "./services/prism.service";
import { APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { PermissionsService } from './services/permissions.service';
import { PackageService } from "./services/package.service";
import { GlobalErrorHandler } from './handlers/global-error.handler';
import { ThemeRuntimeService } from "./services/theme-runtime.service";

@NgModule({
  declarations: [
    AppComponent,
    InactivityAlertComponent,
    LogoutAlertComponent,
    ExitImpersonationModalComponent,
    ExitImpersonationConfirmModalComponent,
    ImpersonationConfirmModalComponent,
    TestComponent,
    MeteringSectionFormBuilderComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    CommonModule,
    FormioModule,
    NgbTooltipModule,
    AppCommonModule.forRoot(),
    NavigationModule.forRoot(),
    NgxGoogleAnalyticsModule.forRoot("G-VPPEHKT6LC"),
    GoogleTagManagerModule.forRoot({ id: "G-VPPEHKT6LC" }),
  ],
  providers: [
    { provide: "googleTagManagerId", useValue: "G-VPPEHKT6LC" },
    provideHttpClient(withInterceptorsFromDi()), // Correct way in Angular 15
    { provide: HTTP_INTERCEPTORS, useClass: SecurityHeadersInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: GlobalErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    CookieService,
    PrismService,
    PermissionsService,
    PackageService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadPermissions,
      deps: [PermissionsService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializePackage,
      deps: [PackageService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeThemeRuntime,
      deps: [ThemeRuntimeService],
      multi: true
    }
  ],
})
export class AppModule {}
export function loadPermissions(service: PermissionsService) {
  return () => service.load();
}

export function initializePackage(service: PackageService) {
  return () => service.load();
}

export function initializeThemeRuntime(service: ThemeRuntimeService) {
  return () => service.initialize();
}
